import * as actionTypes from '../action-types'
import { userType } from 'Common/constants'

const initialState = {
  type: null,
  storeId: 0,
  data: null
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATE_USER_TYPE:
      switch (payload) {
        case userType.PM.key:
          sessionStorage.setItem('token', 'OXKslHF63drJ9urZjqDx');
          break;

        case userType.S.key:
          sessionStorage.setItem('token', 'ForJHXwF5FxROXpyUZ2C');
          break;

        case userType.AM.key:
          sessionStorage.setItem('token', 'BMPoBRB8kZ6NWmk2lSBX');
          break;

        case userType.SC.key:
          sessionStorage.setItem('token', 'BMPoBRB8kZ6NWmk2lSBD');
          break;

        case userType.FIN.key:
          sessionStorage.setItem('token', 'AMPoRB8k6NWmk2lSBDg2');
          break;

        default:
          sessionStorage.removeItem('token');
      }

      return {
        ...state,
        type: payload
      }

    case actionTypes.UPDATE_USER:
      return {
        ...state,
        ...payload
      };

    default:
      return state
  }
}
export default reducer



// WEBPACK FOOTER //
// ./src/redux-store/reducers/user-reducer.js